<template>
  <el-dialog
    :title="title"
    :visible.sync="drawer"
    :direction="'ltr'"
    :append-to-body="true"
    :modal-append-to-body="true"
    size="40%"
    :wrapperClosable="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
  >
    <div class="drawer-content">
      <el-form
        class="drawer-form"
        ref="form"
        :model="requestData"
        label-width="130px"
      >
        <el-form-item label="留样名称">
          <el-input
            class="input"
            v-model.trim="requestData.sampleFoodName"
            placeholder="请输入留样名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="留样量">
          <el-input
            class="input"
            v-model.trim="requestData.sampleQuantity"
            placeholder="请输入留样量"
          ></el-input>
        </el-form-item>
        <el-form-item label="留样时间">
          <el-date-picker
            class="picker"
            type="date"
            placeholder="请选择留样时间"
            v-model="selectDate"
            value-format="timestamp"
            :picker-options="pickerOptions"
            @change="changeDate"
            style="width: 100%;"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="留样人">
          <el-input
            class="input"
            v-model.trim="requestData.retentionSamplesAre"
            placeholder="请输入留样人名字"
          ></el-input>
        </el-form-item>
        <el-form-item label="留样联系人电话">
          <el-input
            class="input"
            v-model.trim="requestData.leaveSampleNumber"
            placeholder="请输入联系人电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="样品存放地点">
          <el-input
            class="input"
            v-model.trim="requestData.sampleStorageLocation"
            placeholder="请输入样品存放地点"
          ></el-input>
        </el-form-item>
        <el-form-item label="留样影像">
          <upload-image
            class="img"
            accept='image/*'
            v-model.trim="requestData.samplePicturesUrl"
            :uploadLimit="3"
            style="width:90%"
          ></upload-image>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            class="input"
            type="textarea"
            v-model.trim="requestData.remark"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="submitForm()">
            确定
          </el-button>
          <el-button size="small" @click="resetForm()">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import UploadImage from "@/components/UploadImage";
export default {
  name: "sampleManagementOperate",
  components: {
    UploadImage
  },
  props: {
    operateResize: {
      type: Number,
      default: {
        return: 0
      }
    },
    drawerType: {
      type: String,
      default: {
        return: ""
      }
    },
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      drawer: false,
      title: "新增留样记录",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      requestData: {
        sampleFoodName: "",
        leaveSampleNumber: "",
        sampleTime: "",
        retentionSamplesAre: "",
        sampleQuantity: "",
        sampleStorageLocation: "",
        samplePicturesUrl: "",
        remark: ""
      },
      initData: {
        sampleFoodName: "", // 留样名称
        leaveSampleNumber: "", // 留样联系人电话
        sampleTime: "", // 留样时间
        retentionSamplesAre: "", // 留样人
        sampleQuantity: "", // 留样量
        sampleStorageLocation: "", // 样品存放地点
        samplePicturesUrl: "", // 留样影像(多个文件或图片用逗号隔开)
        remark: "" // 备注
      },
      selectDate: ""
    };
  },
  created() {},
  mounted() {},
  computed: {
    diningRoomId() {
      return this.$store.state.diningRoomId;
    }
  },
  watch: {
    operateResize: function(newVal) {
      this.drawer = true;
      if (this.drawerType == "add") {
        this.title = "新增留样记录";
        let obj = Object.assign({}, this.initData, {
          diningId: this.diningRoomId
        });
        this.requestData = JSON.parse(JSON.stringify(obj));
      } else {
        this.title = "编辑留样记录";
        let obj = this.editData;
        this.requestData = JSON.parse(JSON.stringify(obj));
        // console.log(this.requestData.samplePicturesUrl);
        // console.log(this.requestData.sampleTime);
        this.selectDate = this.requestData.sampleTime * 1000;
        // console.log(this.requestData.sampleTime);
      }
    }
  },
  methods: {
    clearData() {
      this.requestData = Object.assign({}, this.initData);
      this.selectDate = "";
    },
    changeDate() {
      // console.log(this.selectDate);
      this.requestData.sampleTime = this.selectDate / 1000;
      // console.log(this.requestData.sampleTime);
    },
    handleClose(done) {
      this.drawer = false;
      this.clearData();
    },
    submitForm() {
      if (this.requestData.sampleFoodName == "") {
        this.$message("请输入留样名称");
        return;
      }
      if (this.requestData.sampleQuantity == "") {
        this.$message("请输入留样量");
        return;
      }
      if (this.requestData.sampleTime == "") {
        this.$message("请选择留样时间");
        return;
      }
      if (this.requestData.retentionSamplesAre == "") {
        this.$message("请输入留样人名字");
        return;
      }
      if (
        this.$Common.checkPhoneNumber(this.requestData.leaveSampleNumber) ==
        false
      ) {
        this.$message("请输入正确的手机号码！");
        return false;
      }
      if (this.requestData.sampleStorageLocation == "") {
        this.$message("请输入样品存放地点");
        return;
      }
      this.addOrEditSample();
    },
    resetForm() {
      this.drawer = false;
      this.clearData();
    },
    // 新增/编辑 留样记录
    async addOrEditSample() {
      let req = this.requestData;
      let res;
      if (this.drawerType == "add") {
        res = await this.$Http.addSample(req);
      } else {
        res = await this.$Http.updateSample(req);
      }
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.messsage
        });
        this.handleClose();
        this.$parent.getSampleList();
      } else if (res.code == 101) {
        this.handleClose();
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.drawer-form {
  .input {
    width: 250px;
    input {
      width: 100%;
    }
  }
  .select {
    width: 250px;
  }
  .picker {
    width: 250px !important;
  }
  .img {
    width: 250px;
  }
}
</style>
